import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { Webisode } from 'api/types/webisode'

// Webisode API service class
class WebisodeClass {
  // fetch list of webisodes
  async getWebisodesList(): Promise<Webisode[] | AxiosError | Error> {
    const url = APIRoutes.webisodes.getWebisodesList
    return ApiProvider.getRequest(url) as Promise<
      Webisode[] | AxiosError | Error
    >
  }

  async getWebisode({
    id,
  }: {
    id: string
  }): Promise<Webisode | AxiosError | Error> {
    const url = `${APIRoutes.webisodes.getWebisode}?id=${id}`
    return ApiProvider.getRequest(url) as Promise<Webisode | AxiosError | Error>
  }

  async deleteWebisode({
    id,
  }: {
    id: string
  }): Promise<any | AxiosError | Error> {
    const url = `${APIRoutes.webisodes.deleteWebisode}?id=${id}`
    return ApiProvider.deleteRequest(url) as Promise<any | AxiosError | Error>
  }

  // create or update a webisode
  async saveWebisode({
    id,
    title,
    content,
    description,
    label,
    link,
  }: Webisode): Promise<string | AxiosError | Error> {
    const url = APIRoutes.webisodes.saveWebisode
    const body = new FormData()
    if (id) body.append('id', id)
    if (title) body.append('title', title)
    if (content) body.append('content', content)
    if (description) body.append('description', description)
    if (label) body.append('label', label)
    if (link) body.append('link', link)

    return ApiProvider.postRequest(url, body, true) as Promise<
      string | AxiosError | Error
    >
  }
}

export const webisodeService = new WebisodeClass()
